import React, { useState, useEffect, useRef } from 'react';
import './styles.css'; // Import your CSS file
import VerticalInputText from "./VerticalInputText";
//import '@fontawesome/fontawesome-free/css/all.css';
import LocationFetcher from './LocationFetcher';

import ReactDOM from 'react-dom';
import ReactStars from "react-rating-stars-component";
//import RatingComponent from "./RatingComponent";
//import UserAuthComponent from './UserAuthComponent';
//import L from 'leaflet';
//import 'leaflet/dist/leaflet.css';

import SongMetadataEditor, { SongDataProvider, useUpdateSongData } from './SongMetadataEditor';



const MyPage = () => {
    const initialized = useRef(false);
    const [page, setPage] = useState(window.location.pathname);
    const [currentSongData, setCurrentSongData] = useState({});

    const [currentSongRating, setCurrentSongRating] = useState(0);
    const [currentPack, setCurrentPack] = useState("mostpop");
    //const [currentSongFix, setCurrentSongFix] = useState("");
    /*
        const handleRatingChange = (newRating) => {
            console.log("New Rating 2:", newRating);
            window.rateSong(newRating);
            setCurrentSongRating(newRating);
        };
        */
    const [pageLoaded, setPageLoaded] = useState(false);
    const [firstSearchDone, setFirstSearchDone] = useState(false);
    const [locationData, setLocationData] = useState({});


    const handlePackChange = (newPack, shouldBuildPlaylist) => {
        console.log("New Pack:", newPack);

        if (newPack == "mostpop") {
            window.loadDefaultPageData(shouldBuildPlaylist);
            return;
        }
        let dataFile = "";
        if (newPack == "sample1") {
            dataFile = "/essentialsPageData.json";
        }
        else if (newPack == "rapfr") {
            dataFile = "/pageData_1434_Q142_1970-2025_xxx.json";
        }
        else if (newPack == "tests") {
            dataFile = "/pageDataToFix.json";
        }
        else if (newPack == "benin") {
            dataFile = "/pageData__Q962_0-2025_xxx.json";
        }
        if (dataFile == "") {
            console.log("Invalid pack selected:" + JSON.stringify(newPack));
            return;
        }
        window.loadPageData(dataFile, locationData, shouldBuildPlaylist);
        //updateFilter()
    }

    const handleLocationObtained = (locationData) => {
        console.log("User location:", locationData);
        setLocationData(locationData);
        window.selectPlacesNearby(locationData);

        /*
        window.loadPageData("/essentialsPageData.json");
        //navigateToNewPage("");
        //if (window.getPlaylistLength() > 0) {
        setTimeout(() => {
            setFirstSearchDone(true);
            window.selectPlacesNearby(locationData);
            window.refreshMap();
        }, 2000);

        setTimeout(() => {
            window.refreshMap();
        }, 10000);
        */


        // Perform any processing or API calls with the location data here
    };

    const updateRating = () => {
        console.log("Updating rating...");
        console.log("Current rating:", currentSongRating);
        if (typeof window.getSongRating === "function") {
            const newRating = window.getSongRating();
            console.log("New rating:", newRating);
            setCurrentSongRating(newRating);
        }
        console.log("Rating updated!");
    }

    const handleSave = (updatedData) => {
        console.log("Saved data:", updatedData);
    };

    const getCurrentSongId = () => {
        try {
            return window.getCurrentSongId();
        }
        catch (e) {
            console.log("Error getting current song ID:", e);
            return 0;
        }
        //return window.getCurrentSongId();
    };

    const handleAddTag = (entity, category, tag) => {
        console.log(`Added tag '${tag}' to category '${category}' in '${entity}'`);
        if (entity.indexOf("artists") == 0) {
            let artistId = entity.split(".")[1];
            document.getElementById("editedSong").innerHTML += artistId + ":" + category + ":a:" + tag + "|";
        }
        else
            document.getElementById("editedSong").innerHTML += category + ":a:" + tag + "|";
    };

    const handleDeleteTag = (entity, category, tag) => {
        console.log(`Deleted tag '${tag}' from category '${category}' in '${entity}'`);
        if (entity.indexOf("artists") == 0) {
            let artistId = entity.split(".")[1];
            document.getElementById("editedSong").innerHTML += artistId + ":" + category + ":d:" + tag + "|";
        }
        else
            document.getElementById("editedSong").innerHTML += category + ":d:" + tag + "|";
    };

    useEffect(() => {
        const loadCSS = (href) => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        };

        const loadScript = (src) => {
            return new Promise((resolve, reject) => {
                const script = document.createElement("script");
                script.src = src;
                script.async = true;
                script.onload = resolve;
                script.onerror = reject;
                document.body.appendChild(script);
            });
        };

        //window.history.pushState({}, '', '/loading');
        const handleBackButton = (event) => {
            // Your custom logic here
            //setFirstSearchDone(false);
            //setPage(window.location.pathname); 
            console.log("User attempted to navigate back");
            setPage(window.location.pathname);
            setFirstSearchDone(false);
        };

        // Attach event listener
        window.addEventListener('popstate', handleBackButton);

        // Ensure the initial state is pushed only once
        if (!initialized.current) {
            window.history.replaceState({}, '', window.location.pathname);
            initialized.current = true;
        }

        // Load CSS libraries
        loadCSS("https://cdnjs.cloudflare.com/ajax/libs/toastr.js/2.1.4/toastr.css");
        loadCSS("https://unpkg.com/leaflet/dist/leaflet.css");
        loadCSS("https://cdnjs.cloudflare.com/ajax/libs/noUiSlider/15.6.1/nouislider.min.css");
        loadCSS("/Control.FullScreen.css");

        // Load Y.js and Z.js before X.js
        Promise.all([
            loadScript("/allGenres.js"),
            loadScript("/allLocations.js"),
            loadScript("/allStyles.js"),
            loadScript("/allTags.js"),
            loadScript("/locationHierarchy.js"),
            loadScript("/pageData.js"),
            loadScript("/ttData.js"),
            loadScript("/fixes.js"),
            loadScript("https://code.jquery.com/jquery-3.5.1.min.js"),
            loadScript("https://cdnjs.cloudflare.com/ajax/libs/noUiSlider/15.6.1/nouislider.min.js"),
            loadScript("https://unpkg.com/leaflet/dist/leaflet.js"),
            loadScript("https://cdnjs.cloudflare.com/ajax/libs/toastr.js/2.1.4/toastr.min.js"),
            loadScript("/Control.FullScreen.js")
        ])
            .then(() => loadScript("/genius.js")) // Load X.js after Y.js and Z.js
            .then(() => {
                console.log("All scripts loaded successfully");

                //window.toastr.success("Libraries are ready!");
                window.setExternalRating(window.getSongRating());
                setPageLoaded(true);
                setTimeout(() => {
                    //window.loadFirstSearch();
                    //setFirstSearchDone(true);
                }, 5000);

            })
            .catch((err) => {
                console.error("Error loading scripts:", err);
            });


        // Cleanup on component unmount
        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };
    }, []);

    const submitPlayList1 = () => {
        window.applyFirstSearch(locationData);
        navigateToNewPage("");
        if (window.getPlaylistLength() > 0) {
            setTimeout(() => {
                setFirstSearchDone(true);
                window.refreshMap();

            }, 1000);

            setTimeout(() => {
                window.refreshMap();
            }, 10000);
        }
        /*
        if (currentPack == "mostpop") {
            window.loadDefaultPageData();
            window.applyFirstSearch(locationData);
            navigateToNewPage("");
            if (window.getPlaylistLength() > 0) {
                setTimeout(() => {
                    setFirstSearchDone(true);
                    window.refreshMap();

                }, 1000);

                setTimeout(() => {
                    window.refreshMap();
                }, 10000);
            }
        }
        else {
            let dataFile = "";
            if (currentPack == "sample1") {
                dataFile = "/essentialsPageData.json";
            }
            else if (currentPack == "rapfr") {
                dataFile = "/pageData_1434_Q142_1970-2025_xxx.json";
            }
            else if (currentPack == "tests") {
                dataFile = "/pageDataToFix.json";
            }
            else if (currentPack == "benin") {
                dataFile = "/pageData__Q962_0-2025_xxx.json";
            }

            if (dataFile == "") {
                console.log("Invalid pack selected:" + JSON.stringify(currentPack));
                return;
            }
            //window.loadPageData(dataFile, locationData);
            window.applyFirstSearch(locationData);
            navigateToNewPage("");
            if (window.getPlaylistLength() > 0) {
                setTimeout(() => {
                    setFirstSearchDone(true);
                    window.refreshMap();
                }, 2000);

                setTimeout(() => {
                    window.refreshMap();
                }, 10000);
            }
        }
        */


    }

    /*

    useEffect(() => {
        //window.history.pushState({}, '', '/loading');
        const handleBackButton = (event) => {
            // Your custom logic here
            //setFirstSearchDone(false);
            //setPage(window.location.pathname); 
            console.log("User attempted to navigate back");
            setPage(window.location.pathname); 
            setFirstSearchDone(false);
        };

        // Attach event listener
        window.addEventListener('popstate', handleBackButton);

        // Ensure the initial state is pushed only once
        if (!initialized.current) {
            window.history.replaceState({}, '', window.location.pathname);
            initialized.current = true;
        }

        // Cleanup on component unmount
        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };
    }, []);

    */



    const navigateToNewPage = (page) => {
        setPage("/" + page);
        window.history.pushState({}, '', '/' + page);
        console.log("Navigated to a new page");
    };
    //const [skimLength, setValue] = useState("30");

    const handleSkimLength = (newValue) => {
        window.setSkimLength(newValue);
    };

    const handleStartTime = (newValue) => {
        window.setStartTime(newValue);
    };

    const getRating = () => {
        return window.getSongRating();
    }


    const setGlobalUpdateFunction = useUpdateSongData();

    useEffect(() => {
        // Expose the update function to the global scope
        window.updateSongData = setGlobalUpdateFunction;
        return () => {
            delete window.updateSongData; // Cleanup on unmount
        };
    }, [setGlobalUpdateFunction]);


    return (
        <div id="app0"
            style={{ "flex": "none", flexDirection: "column", flex: "1" }}
        >
            {/*<p>Current page: {page}</p>*/}
            <div id="loading" style={{
                display: (pageLoaded && firstSearchDone) ? "none" : "flex", flexDirection: "column", flex: "1",
                justifyContent: "center", alignItems: "center", //textAlign: "center" 
            }}>
                {/*
                <h1>The more you like music,<br></br>the more music you like.</h1>
                <div style={{
                    fontSize: "25px", fontStyle: "italic", paddingBottom: "25px", display: "flex",
                    flexDirection: "row", justifyContent: "center", alignItems: "center",
                    minWidth: "80%"
                }}>
                    <div>Track Music through space and time!<br />
                        Fast Explore: a new song every Tick!<br />
                        This is a proof-of-concept. More soon!<br />
                    </div>
                </div>
                */}
                <br></br>
                <div style={{ textAlign: "center" }}>
                    <div class="form-card" style={{ paddingLeft: 10, paddingRight: 10, paddingBottom: 5, paddingTop: 10, backgroundColor: "rgba(224, 209, 209, 0.8)" }}>
                        <h1>The more you like music,<br></br>the more music you like.</h1>
                        <div class="form-group">
                            <div style={{ fontSize: 27 }}>Track Music through space and time!<br />
                                Fast Explore: a new song every Tick!<br />
                                This is a proof-of-concept. More soon!<br />
                            </div>
                        </div>
                    </div>
                </div>
                <br></br>

                <div class="form-card">
                    <h1>What do you want to explore?</h1>
                    <div class="form-group">
                        <label for="pack">Pack</label>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
                            <select value={currentPack}
                                style={{ padding: "5px 5px", fontSize: "30px", width: "600px" }}
                                name="packOptions"
                                id="packOptions"
                                onChange={(evt) => {
                                    setCurrentPack(evt.target.value);
                                    handlePackChange(evt.target.value);
                                }
                                }
                            ><option value="mostpop">Default | Most Popular (20K+ songs)</option>
                                <option value="sample1">Sample | Balanced (95K+ songs) </option>
                                <option value="rapfr">All French Rap (70K+ songs)</option>
                                <option value="benin">Benin (400+ songs)</option>
                                <option value="tests">Tests</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="genre">Genre(s) or Theme(s)</label>
                        <select
                            style={{
                                padding: "5px 5px",
                                fontSize: "35px",
                                width: "600px",
                                //height: "12%",
                            }}
                            name="genreOptions0"
                            id="genreOptions0"
                            size="5"
                            multiple
                        ></select>
                    </div>
                    <div class="form-group">
                        <label for="years">Year(s)</label>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
                            <input
                                style={{ fontSize: "30px", width: "250px" }}
                                type="text"
                                id="minYear0"
                                placeholder='From:'
                                defaultValue=""
                            />
                            <span style={{ fontSize: "40px" }}>{" "}-{" "}</span>
                            <input
                                style={{ fontSize: "30px", width: "250px" }}
                                type="text"
                                id="maxYear0"
                                placeholder='To:'
                                defaultValue=""
                            />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="location">Location(s)</label>
                        <div style={{ padding: "0px 0px", fontSize: "0.8em", borderWidth: 0, display: "flex", flexDirection: "row" }}                                    >
                            {/*<label for="nearyou">Artists Near Me</label>*/}
                            <LocationFetcher onLocationObtained={handleLocationObtained} />
                        </div>
                        <div style={{ padding: "5px 5px", fontSize: "1.1em", borderWidth: 0, display: "flex", flexDirection: "column" }}  >
                            <label for="notnearyou"> Countries </label>
                            <select
                                style={{
                                    padding: "5px 5px",
                                    fontSize: "40px",
                                    width: "600px",
                                    //height: "12%",
                                }}
                                name="locationOptions0"
                                id="locationOptions0"
                                size="5"
                                multiple
                            ></select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="sort">Sort By</label>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
                            <select
                                style={{ padding: "5px 5px", fontSize: "40px", width: "320px" }}
                                name="sortOptions0"
                                id="sortOptions0"
                            //onChange={() => window.updateSort()}
                            ><option value="d">Release Date</option>
                                <option value="z">Youtube Views</option>
                                <option value="r">Youtube Views+</option>
                                <option value="c">Genius Contributors</option>
                                <option value="w">Genius Page Views</option>
                            </select>

                            <select
                                style={{ padding: "5px 5px", fontSize: "40px", width: "280px" }}
                                name="sortOptionsDir0"
                                id="sortOptionsDir0"
                            >
                                <option value="asc">Ascending &#8593;</option>
                                <option value="desc">Descending &#8595;</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="map">Map Options</label>
                        <select
                            style={{ padding: "5px 5px", fontSize: "40px", width: "600px" }}
                            name="mapPosition0"
                            id="mapPosition0"
                        >
                            <option value="2">Below the video</option>
                            <option value="1">Beside the video</option>
                            <option value="0">No Map</option>
                        </select>
                        <span style={{ fontSize: "30px" }} >(Select "No Map" for older devices)</span>
                    </div>

                    <button class="btn" onClick={
                        () => submitPlayList1()
                    } >
                        PLAY</button>

                </div>
                <br></br>


                <div class="form-card">
                    <h1>Contact us</h1>
                    {/*
                    <div class="form-group">
                        <label for="name">Name</label>
                        <input type="text" id="name" placeholder="Enter your name"></input>
                    </div>
                    <div class="form-group">
                        <label for="email">Email</label>
                        <input type="email" id="email" placeholder="Enter your email"></input>
                    </div>
                    <div class="form-group">
                        <label for="message">Message</label>
                        <textarea id="message" placeholder="Enter your message"></textarea>
                    </div>
                    <button class="btn" onClick={() => {
                        window.sendMessage();
                    }}>
                        Send</button>
                    <br></br>
                    */}
                    <a style={{ fontSize: 30 }} href="https://www.reddit.com/r/TickTrack/" target="_blank" rel="noreferrer">
                        Join the discussion on Reddit
                    </a>
                    <br></br>
                </div>



                <div id="wait" style={{ display: (pageLoaded) ? "none" : "flex", flexDirection: "column", flex: "1", justifyContent: "center", alignItems: "center" }}>
                    <h1>Loading...</h1>
                </div>
                {/*
                <div id="firstSearch" style={{ display: (pageLoaded && !firstSearchDone) ? "flex" : "none", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                    <table style={{ padding: "5px 5px", fontSize: "40px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>

                        <tr >
                            <td style={{ padding: "5px 5px", fontSize: "40px", borderWidth: 5, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}>
                                <span >
                                    Select the genre(s) or theme(s)
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <select
                                    style={{
                                        padding: "5px 5px",
                                        fontSize: "40px",
                                        width: "600px",
                                        //height: "12%",
                                    }}
                                    name="genreOptions0"
                                    id="genreOptions0"
                                    size="5"
                                    multiple
                                ></select>
                            </td>
                        </tr>
                        <tr style={{ paddingTop: "30px" }}  >
                            <td style={{ paddingLeft: "10px", fontSize: "40px", borderWidth: 5, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}>

                                <span style={{}}>
                                    Select the years
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "5px 5px", textAlign: "center" }}>
                                <input
                                    style={{ fontSize: "40px", width: "275px" }}
                                    type="text"
                                    id="minYear0"
                                    placeholder='From:'
                                    defaultValue=""
                                />
                                <span style={{ fontSize: "40px" }}> - </span>
                                <input
                                    style={{ fontSize: "40px", width: "275px" }}
                                    type="text"
                                    id="maxYear0"
                                    placeholder='To:'
                                    defaultValue=""
                                />
                            </td>
                        </tr>
                        <tr style={{ paddingTop: "30px" }}  >
                            <td>
                                <div style={{ padding: "5px 5px", fontSize: "40px", borderWidth: 5, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}                                    >
                                    Music Near You?
                                    <LocationFetcher onLocationObtained={handleLocationObtained} />
                                </div>
                            </td>
                        </tr>
                        <tr style={{ paddingTop: "30px" }}  >
                            <td>
                                <div style={{ padding: "5px 5px", fontSize: "50px", borderWidth: 0, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}                                    >
                                    OR
                                </div>
                            </td>
                        </tr>
                        <tr style={{ paddingTop: "30px" }}  >
                            <td>
                                <div style={{ padding: "5px 5px", fontSize: "40px", borderWidth: 5, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}                                    >
                                    Select a location
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div>
                                    <select
                                        style={{
                                            padding: "5px 5px",
                                            fontSize: "40px",
                                            //height: "12%",
                                            display: "flex",
                                            width: "600px",
                                        }}
                                        name="locationOptions0"
                                        id="locationOptions0"
                                        size="4"
                                        multiple
                                    ></select>
                                </div>
                            </td>
                        </tr>
                        <tr style={{ paddingTop: "30px" }}  >
                            <td style={{ paddingLeft: "10px", fontSize: "40px", borderWidth: 5, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}>

                                <span style={{}}>Sort by</span>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ paddingLeft: "10px" }}>
                                <select
                                    style={{ padding: "5px 5px", fontSize: "40px", width: "320px" }}
                                    name="sortOptions0"
                                    id="sortOptions0"
                                //onChange={() => window.updateSort()}
                                ><option value="d">Release Date</option>
                                    <option value="z">Youtube Views</option>
                                    <option value="r">Youtube Views+</option>
                                    <option value="c">Genius Contributors</option>
                                    <option value="w">Genius Page Views</option>
                                </select>
                                <select
                                    style={{ padding: "5px 5px", fontSize: "40px" }}
                                    name="sortOptionsDir0"
                                    id="sortOptionsDir0"
                                >
                                    <option value="asc">Ascending &#8593;</option>
                                    <option value="desc">Descending &#8595;</option>
                                </select>
                            </td>

                        </tr>
                        <tr style={{ paddingTop: "30px" }}  >
                            <td style={{ paddingLeft: "10px" }}>
                                <div style={{ width: "580px", padding: "5px 5px", fontSize: "40px", borderWidth: 5, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}>
                                    Map Options
                                    <span style={{ display: "block", padding: "5px 5px", fontSize: "25px" }}>
                                        Select "No Map" for older or less powerful devices
                                    </span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ paddingLeft: "10px" }}>
                                <span style={{ display: "flex", fontSize: "40px" }}>
                                    <select
                                        style={{ padding: "5px 5px", fontSize: "40px", width: "600px" }}
                                        name="mapPosition0"
                                        id="mapPosition0"
                                    >
                                        <option value="2">Below the video</option>
                                        <option value="1">Beside the video</option>
                                        <option value="0">No Map</option>
                                    </select>
                                </span>
                            </td>
                        </tr>

                        <tr style={{ paddingTop: "50px" }}  >
                            <td>
                                <div style={{ padding: "5px 5px", fontSize: "40px", borderWidth: 5, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}>
                                    <button
                                        id="firstSearchButton"
                                        style={{
                                            padding: "5px 5px",
                                            fontSize: "40px",
                                            borderWidth: "0px",
                                            backgroundColor: "darkblue",
                                            color: "white",
                                        }}
                                        onClick={() => {
                                            window.applyFirstSearch();
                                            navigateToNewPage("");
                                            if (window.getPlaylistLength() > 0) {
                                                setTimeout(() => {
                                                    setFirstSearchDone(true);
                                                    window.refreshMap();

                                                }, 1000);

                                                setTimeout(() => {
                                                    window.refreshMap();
                                                }, 10000);
                                            }
                                        }
                                        }
                                    >
                                        PLAY THE MUSIC
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr style={{ paddingTop: "30px", fontSize: 20 }}  >
                            <td>
                                ALTERNATIVE PACKS <br />

                                <button
                                    id="loadEssentials"
                                    onClick={() => {
                                        window.loadPageData("/essentialsPageData.json");
                                        //navigateToNewPage("");
                                        //if (window.getPlaylistLength() > 0) {
                                        setTimeout(() => {
                                            setFirstSearchDone(true);
                                            window.refreshMap();
                                        }, 2000);

                                        setTimeout(() => {
                                            window.refreshMap();
                                        }, 10000);
                                        //}
                                    }}
                                    style={{ margin: 15, padding: "5px 5px", fontSize: "20px", borderWidth: 0, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }} >
                                    95K Sample
                                </button>

                                <button
                                    id="loadAllRapFR"
                                    onClick={() => {
                                        window.loadPageData("/pageData_1434_Q142_1970-2025_xxx.json");
                                        navigateToNewPage("");
                                        //if (window.getPlaylistLength() > 0) {
                                        setTimeout(() => {
                                            setFirstSearchDone(true);
                                            window.refreshMap();
                                        }, 2000);

                                        setTimeout(() => {
                                            window.refreshMap();
                                        }, 10000);

                                        //}
                                    }}
                                    style={{ margin: 15, padding: "5px 5px", fontSize: "20px", borderWidth: 0, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }} >
                                    All Rap FR (70K+ songs)
                                </button>


                                <button
                                    id="loadAllBenin"
                                    onClick={() => {
                                        window.loadPageData("/pageData__Q962_0-2025_xxx.json");
                                        navigateToNewPage("");
                                        //if (window.getPlaylistLength() > 0) {
                                        setTimeout(() => {
                                            setFirstSearchDone(true);
                                            window.refreshMap();
                                        }, 2000);
                                        //}
                                    }}
                                    style={{ margin: 15, padding: "5px 5px", fontSize: "20px", borderWidth: 0, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }} >
                                    Benin
                                </button>




                                <button
                                    id="loadDataToFix"
                                    onClick={() => {
                                        window.loadPageData("/pageDataToFix.json");
                                        navigateToNewPage("");
                                        //if (window.getPlaylistLength() > 0) {
                                        setTimeout(() => {
                                            setFirstSearchDone(true);
                                            window.refreshMap();
                                        }, 2000);

                                        setTimeout(() => {
                                            window.refreshMap();
                                        }, 10000);
                                        //}
                                    }}
                                    style={{ margin: 15, padding: "5px 5px", fontSize: "20px", borderWidth: 0, borderRadius: 5, borderStyle: "solid", borderColor: "white", color: "white" }} >
                                    toFix
                                </button>

                            </td>
                        </tr>
                        <tr style={{ paddingTop: "30px" }}  >
                            <td>
                                <a href="https://www.reddit.com/r/TickTrack/" target="_blank" rel="noreferrer">
                                    Join the discussion on Reddit
                                </a>
                            </td>
                        </tr>
                    </table>
                </div>
                */}

            </div>

            <div id="app"
                style={{ display: (pageLoaded && firstSearchDone) ? "flex" : "none", flexDirection: "column", flex: "1" }}
            >
                <div id="tableContainer"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <table >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="container"> {/* onScroll={() => window.noScroll()}> */}
                                        <div
                                            id="iframePlayer1"
                                            style={{ order: 0, overflowX: "hidden" }}
                                            className="iframePlayer1"
                                        >
                                            <div id="player"></div>
                                        </div>
                                        <div
                                            id="iframePlayer2"
                                            style={{ order: 2, overflowX: "hidden" }}
                                            className="iframePlayer2"
                                        >
                                            <div id="player2"></div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr style={{ blackgroundColor: "white", paddingTop: "0px" }}>

                                <div id="control1" style={{
                                    //height: "100px",
                                    //width: "100%",

                                    display: "flex",
                                    flexDirection: "row",
                                    paddingTop: "0px",
                                    //alignItems: "center",
                                    //justifyContent: "center",
                                    //alignContent: "center",
                                    //backgroundColor: 'cornflowerblue'
                                    //gap: "10px", // Space between elements

                                }}>
                                    <div
                                        style={{

                                            display: "none",
                                            padding: "5px 5px",
                                            //justifyContent: "space-between",
                                            alignItems: "center",

                                            flexDirection: "column",


                                            width: "50px",
                                            //color: "#fff",
                                            //fontSize: "50px",
                                            //border: "none",
                                            //borderRadius: "5px",
                                        }}>
                                        <button
                                            id="help"
                                            style={{
                                                display: "inline-flex",
                                                padding: "0px 0px",
                                                paddingBottom: "0px",
                                                marginBottom: "20px",
                                                marginTop: "0px",
                                                backgroundColor: "darkblue",
                                                justifyContent: "center",
                                                alignItems: "center",

                                                width: "50px",
                                                //height: "55px",
                                                color: "#fff",
                                                fontSize: "30px",
                                                border: "none",
                                                borderRadius: "5px",
                                            }}
                                            textAlign="center"
                                            alignContent="center"
                                            onClick={() => window.showHelp()}
                                        >
                                            ?
                                        </button>
                                        <button
                                            id="info"
                                            style={{
                                                padding: "0px 0px",
                                                paddingBottom: "0px",
                                                backgroundColor: "darkblue",
                                                justifyContent: "center",
                                                alignItems: "center",

                                                width: "50px",
                                                //height: "55px",
                                                color: "#fff",
                                                fontSize: "30px",
                                                fontWeight: "bold",
                                                border: "none",
                                                borderRadius: "5px",
                                            }}
                                            textAlign="center"
                                            alignContent="center"
                                            onClick={() => window.getVideoInfo()}
                                        >
                                            i
                                        </button>
                                    </div>

                                    <div style={{
                                        display: "none",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "5px", // Space between elements
                                        margin: "5px 5px",

                                    }}>
                                        <button
                                            id="switchStart"
                                            className="button2"
                                            style={{ padding: "2px 4px", fontSize: "40px" }}
                                            onClick={() => window.switchStartTime()}
                                        >
                                            Start
                                            <br />
                                            Time
                                        </button>
                                        <VerticalInputText onInputChange={handleStartTime} defaultValue="60" label="secs" />
                                    </div>

                                    <div style={{
                                        display: "inline-flex",
                                        flexDirection: "row",
                                        //marginLeft: "30px",
                                        //alignItems: "center",
                                        justifyContent: "flex-end",
                                        //alignContent: "flex-end",
                                        //width: "100%",
                                        backgroundColor: "white",
                                        gap: "5px", // Space between elements
                                        margin: "5px 5px",
                                        padding: "5px 5px",
                                        borderWidth: 5,
                                        borderRadius: 5,
                                        borderStyle: "solid",
                                        borderColor: "darkblue",
                                    }}
                                    >

                                        <div
                                            style={{
                                                fontSize: "50px",
                                                display: "inline-flex",
                                                flexDirection: "column",
                                                //alignItems: "center",
                                                //borderLeftWidth: "10px",
                                                //backgroundColor: "grey",
                                                width: "100%",

                                                //justifyContent: "flex-end",
                                                //alignContent: "flex-end",
                                                //alignItems: "flex-end",
                                                gap: "5px", // Space between elements
                                                margin: "0px 0px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "50px",
                                                    display: "inline-flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    paddingTop: "0px",
                                                    gap: "5px", // Space between elements
                                                }}
                                            >
                                                {/*
                                            <button
                                                id="back"
                                                style={{
                                                    padding: "0px 0px",
                                                    paddingBottom: "10px",
                                                    backgroundColor: "darkblue",
                                                    width: "50px",
                                                    //height: "55px",
                                                    color: "#fff",
                                                    fontSize: "50px",
                                                    border: "none",
                                                    borderRadius: "5px",
                                                }}
                                                textAlign="center"
                                                alignContent="center"
                                                onClick={() => window.playNextVideo(-1)}
                                            >
                                            */}
                                                <button
                                                    id="skimMode"
                                                    className="button2"
                                                    textAlign="center"
                                                    alignContent="center"
                                                    style={{
                                                        //padding: "2px 4px",
                                                        //height: "55px",
                                                        fontSize: "70px",
                                                        padding: "0px 0px",
                                                        paddingBottom: "10px",
                                                        backgroundColor: "lightgray",
                                                        width: "130px",
                                                        color: "black",
                                                        border: "none",
                                                        borderRadius: "5px",

                                                    }}
                                                    onClick={() => window.switchSkim()}
                                                >Tick
                                                </button>
                                                <VerticalInputText onInputChange={handleSkimLength} defaultValue="30" label="secs" />
                                            </div>



                                        </div>
                                    </div>

                                    <div style={{
                                        display: "inline-flex",
                                        flexDirection: "row",
                                        //marginLeft: "30px",
                                        //alignItems: "center",
                                        justifyContent: "flex-end",
                                        //alignContent: "flex-end",
                                        //width: "100%",
                                        backgroundColor: "white",
                                        gap: "5px", // Space between elements
                                        margin: "5px 5px",
                                        padding: "5px 5px",
                                        borderWidth: 5,
                                        borderRadius: 5,
                                        borderStyle: "solid",
                                        borderColor: "darkblue",
                                    }}
                                    >

                                        <div
                                            style={{
                                                fontSize: "50px",
                                                display: "inline-flex",
                                                flexDirection: "column",
                                                //alignItems: "center",
                                                //borderLeftWidth: "10px",
                                                //backgroundColor: "grey",
                                                width: "100%",

                                                //justifyContent: "flex-end",
                                                //alignContent: "flex-end",
                                                //alignItems: "flex-end",
                                                gap: "5px", // Space between elements
                                                margin: "0px 0px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "50px",
                                                    display: "inline-flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    paddingTop: "0px",
                                                    gap: "5px", // Space between elements
                                                }}
                                            >
                                                {/*
                                            <button
                                                id="back"
                                                style={{
                                                    padding: "0px 0px",
                                                    paddingBottom: "10px",
                                                    backgroundColor: "darkblue",
                                                    width: "50px",
                                                    //height: "55px",
                                                    color: "#fff",
                                                    fontSize: "50px",
                                                    border: "none",
                                                    borderRadius: "5px",
                                                }}
                                                textAlign="center"
                                                alignContent="center"
                                                onClick={() => window.playNextVideo(-1)}
                                            >
                                            */}
                                                <button
                                                    id="back"
                                                    className="button2"
                                                    textAlign="center"
                                                    alignContent="center"
                                                    style={{
                                                        //padding: "2px 4px", 
                                                        fontSize: "70px",
                                                        padding: "0px 0px",
                                                        paddingBottom: "10px",
                                                        backgroundColor: "darkblue",
                                                        width: "80px",
                                                        //height: "55px",
                                                        color: "#fff",
                                                        border: "none",
                                                        borderRadius: "5px",

                                                    }}
                                                    onClick={() => window.playNextVideo(-1)}
                                                >{"  "}
                                                    &#8249;{"  "}
                                                </button>
                                                <span id="trackNumber" style={{ fontSize: "30px" }}>
                                                    <input
                                                        style={{ fontSize: "30px", width: "3.5em" }}
                                                        type="text"
                                                        id="playlistPosition"
                                                        defaultValue="0"
                                                        onSubmit={() => {
                                                            window.setPosition();
                                                            document.activeElement.blur();
                                                        }}
                                                        onBlur={() => window.setPosition()}
                                                    />{" "}
                                                    /{" "}

                                                    <span id="playlistLength" style={{ fontSize: "30px", minWidth: "6ch", display: "inline-block", textAlign: "right" }}>
                                                        0
                                                    </span>
                                                </span>
                                                <button
                                                    id="skip"
                                                    className="button2"
                                                    textAlign="center"
                                                    alignContent="center"
                                                    style={{
                                                        //padding: "2px 4px", 
                                                        fontSize: "70px",
                                                        padding: "0px 0px",
                                                        paddingBottom: "10px",
                                                        backgroundColor: "darkblue",
                                                        width: "80px",
                                                        //height: "55px",
                                                        color: "#fff",
                                                        border: "none",
                                                        borderRadius: "5px",

                                                    }}
                                                    onClick={() => window.playNextVideo()}
                                                >
                                                    {"  "}
                                                    &#8250;{"  "}
                                                </button>
                                                {/*
                                            <button
                                                id="skip"
                                                style={{
                                                    padding: "0px 0px",
                                                    paddingBottom: "10px",
                                                    backgroundColor: "darkblue",
                                                    width: "50px",
                                                    //height: "55px",
                                                    color: "#fff",
                                                    fontSize: "50px",
                                                    border: "none",
                                                    borderRadius: "5px",
                                                }}
                                                textAlign="center"
                                                alignContent="center"
                                                onClick={() => window.playNextVideo()}
                                            >
                                                &#8250;
                                            </button>
                                            */}
                                                <button
                                                    id="shuffle"
                                                    className="button2"
                                                    style={{
                                                        padding: "10px 10px",
                                                        paddingBottom: "10px",
                                                        paddingTop: "10px",
                                                        fontSize: "30px",
                                                        backgroundColor: "darkblue",
                                                        color: "#fff",
                                                        height: "50px",
                                                        fontWeight: "bold",
                                                        //width: "100%",
                                                        //flexGrow: "1",
                                                    }}
                                                    onClick={() => window.shufflePlaylist()}
                                                >
                                                    Shuffle
                                                </button>
                                            </div>


                                        </div>
                                    </div>
                                    {/*
                                    <div style={{
                                        display: "inline-flex",
                                        flexDirection: "row",
                                        //alignItems: "center",
                                        //justifyContent: "center",
                                        gap: "5px", // Space between elements
                                        margin: "5px 5px",
                                        padding: "5px 5px",
                                        borderWidth: 5,
                                        borderRadius: 5,
                                        borderStyle: "solid",
                                        borderColor: "darkblue",
                                    }}>
                                        <button
                                            id="skimMode"
                                            className="button2"
                                            style={{ padding: "2px 4px", fontSize: "40px" }}
                                            onClick={() => window.switchSkim()}
                                        >
                                            Tick
                                            <br />
                                            mode
                                        </button>
                                        <VerticalInputText onInputChange={handleSkimLength} defaultValue="30" label="secs" />
                                    </div>
                                    */}

                                    <div id="control2" style={{ display: "none" }}>
                                        <button
                                            id="skimMode2"
                                            className="button2"
                                            style={{ padding: "2px 4px" }}
                                            onClick={() => window.switchSkim()}
                                        >
                                            mix
                                        </button>
                                        <button
                                            id="switchStart2"
                                            className="button2"
                                            style={{ padding: "2px 4px" }}
                                            onClick={() => window.switchStartTime()}
                                        >
                                            H
                                        </button>
                                        <button
                                            id="shuffle"
                                            className="button2"
                                            style={{
                                                padding: "0px 0px",
                                                backgroundColor: "#fff",
                                            }}
                                            onClick={() => window.shufflePlaylist()}
                                        >
                                            &#128256;
                                        </button>
                                        <button
                                            id="back"
                                            style={{
                                                padding: "1px 10px",
                                                backgroundColor: "cornflowerblue",
                                                color: "#fff",
                                                fontSize: "20px",
                                                border: "none",
                                                borderRadius: "5px",
                                            }}
                                            onClick={() => window.playNextVideo(-1)}
                                        >
                                            &#8249;
                                        </button>
                                        <span id="trackNumber2" style={{ fontSize: "15px" }}>
                                            0 / 0
                                        </span>
                                        <button
                                            id="skip"
                                            style={{
                                                padding: "1px 10px",
                                                backgroundColor: "cornflowerblue",
                                                color: "#fff",
                                                fontSize: "20px",
                                                border: "none",
                                                borderRadius: "5px",
                                            }}
                                            onClick={() => window.playNextVideo()}
                                        >
                                            &#8250;
                                        </button>
                                    </div>
                                </div>
                            </tr>
                            {/* Sign up / Sign in  or Signout button depending + login data 
                        <tr>
                            <table>
                                <tr>
                            <div id="signIn" style={{ display: "flex" }}>
                                <button
                                    id="signInButton"
                                    style={{
                                        padding: "5px 5px",
                                        fontSize: "20px",
                                        borderWidth: "0px",
                                        backgroundColor: "white",
                                        color: "darkblue",
                                    }}
                                    onClick={() => window.signIn()}
                                >
                                    Sign In
                                </button>
                            </div>
                            <div id="signOut" style={{ display: "flex" }}>
                                <button
                                    id="signOutButton"
                                    style={{
                                        padding: "5px 5px",
                                        fontSize: "20px",
                                        borderWidth: "0px",
                                        backgroundColor: "white",
                                        color: "darkblue",
                                    }}
                                    onClick={() => window.signOut()}
                                >
                                    Sign Out
                                </button>
                            </div>
                            <div id="loginData" style={{ display: "none" }}>
                                <span id="loginDataText" style={{ padding: "5px 5px", fontSize: "20px" }}>
                                    ...
                                </span>
                            </div>
                            </tr>
                            </table>
                            
                        </tr>
                        */}
                            <tr>
                                <table style={{ backgroundColor: "white", width: "800px" }}>
                                    <tr style={{ padding: "5px 5px", fontSize: "48px", backgroundColor: "lightgray" }}>
                                        <td>
                                            <div id="filterTab" style={{ padding: "19px 19px", display: "flex", color: "white", backgroundColor: "darkblue" }} onClick={() => window.switchTab("filterTab")}>
                                                Explore
                                            </div>
                                        </td>
                                        <td>
                                            <div id="ratingTab" style={{ padding: "19px 19px", display: "flex", color: "black" }} onClick={() => {
                                                //window.updateRating();
                                                updateRating();
                                                //setCurrentSongRating(window.getSongRating());
                                                //alert("Rating: " + window.getSongRating());
                                                //window.setExternalRating(window.getSongRating());
                                                window.switchTab("ratingTab");

                                                /*
                                                try {
                                                    window.setExternalRating(window.getSongRating());
                                                }
                                                catch (e) {
                                                    console.log("Error setting rating: ", e);
                                                }
                                                    */

                                            }
                                            }>
                                                Save
                                            </div>
                                        </td>
                                        <td>
                                            <div id="statsTab" style={{ padding: "19px 19px", display: "flex", color: "black" }} onClick={() => window.switchTab("statsTab")}>
                                                Stats
                                            </div>
                                        </td>
                                        <td>
                                            <div id="libraryTab" style={{ padding: "19px 19px", display: "flex", color: "black" }} onClick={() => window.switchTab("libraryTab")}>
                                                Library
                                            </div>
                                        </td>
                                        <td>
                                        </td>
                                        <td>
                                        </td>
                                        <td style={{ backgroundColor: "lightgray" }}>
                                            <div id="fixTab" style={{ padding: "19px 19px", display: "flex", color: "black" }} onClick={() => {
                                                window.switchTab("fixTab");
                                            }
                                            }>
                                                <i class="fas fa-edit"></i>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </tr>
                            <div id="ratingTable" style={{ display: "none", backgroundColor: "white", width: "800px" }}>
                                <tr>
                                    <table>
                                        <tr style={{ padding: "5px 5px", fontSize: "30px" }}>
                                            <div id="songToRate" style={{ padding: "5px 5px", fontSize: "25px", minWidth: "50ch" }}>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "row" }}>



                                                <div id="currentSongRating" class="rating-container">
                                                </div>
                                                <span id="songRating" style={{ padding: "5px 5px", fontSize: "30px" }}>
                                                    ()
                                                </span>





                                                {/*
                                            Change 
*/}
                                            </div>

                                        </tr>
                                    </table>
                                </tr>
                            </div>
                            <div id="fixTable" style={{ display: "none", backgroundColor: "white", width: "800px" }}>
                                <tr>
                                    <table>
                                        <tr style={{ display: "flex", flexDirection: "column", padding: "5px 5px", alignItems: "center", justifyContent: "center", alignContent: "center" }}>
                                            <div id="songToFix" style={{ padding: "5px 5px", fontSize: "25px", }}>
                                            </div>
                                            <div class="form-card" style={{ width: "620px" }}>
                                                <div class="form-group">
                                                    <label for="fixLink">Preferred Youtube link</label>
                                                    <div id="preferredVideo" style={{ padding: "5px 5px" }}>
                                                        <input
                                                            //style={{ fontSize: "40px", width: "19em" }}
                                                            type="text"
                                                            id="pVideo"
                                                            defaultValue=""
                                                            onSubmit={(text) => {
                                                                //window.updateFilter();
                                                                //window.applyVideoLinkChange(text);
                                                                //document.activeElement.blur();
                                                            }
                                                            }
                                                            onBlur={(e) => {
                                                                //window.updateFilter()
                                                                window.applyVideoLinkChange(e.target.value);
                                                            }
                                                            }
                                                        />
                                                    </div>
                                                    <span style={{ fontSize: "30px" }} >(0 to skip the video)</span>
                                                </div>

                                                <div class="form-group">
                                                    <label for="fixLink"> Fix the release date </label>
                                                    <div id="fixDate" style={{ padding: "5px 5px" }}>
                                                        <input
                                                            //style={{ fontSize: "40px", width: "19em" }}
                                                            type="text"
                                                            id="fixedDate"
                                                            defaultValue=""
                                                            onSubmit={() => {
                                                                //window.updateFilter();
                                                                //document.activeElement.blur();
                                                            }
                                                            }
                                                            onBlur={() => {
                                                                //window.updateFilter()
                                                            }
                                                            }
                                                        />
                                                    </div>
                                                    <span style={{ fontSize: "30px" }} >(YYYY-MM-DD)</span>
                                                </div>
                                            </div>

                                            <div class="form-card" style={{ marginTop: "20px", width: "620px" }}>
                                                <h2> Edit Video Info (Advanced Users) </h2>
                                                <div class="form-group">

                                                    <label > Number of views </label>
                                                    <div id="fixViews" style={{ padding: "5px 5px" }}>
                                                        <input
                                                            //style={{ fontSize: "40px", width: "19em" }}
                                                            type="text"
                                                            id="fixedViews"
                                                            defaultValue=""
                                                            onSubmit={() => { }}
                                                            onBlur={() => { }}
                                                        />
                                                    </div>
                                                </div>

                                                <div class="form-group">
                                                    <label > Cumulated Number of Views </label>
                                                    <div id="fixViews+" style={{ padding: "5px 5px" }}>
                                                        <input
                                                            //style={{ fontSize: "40px", width: "19em" }}
                                                            type="text"
                                                            id="fixedViews+"
                                                            defaultValue=""
                                                            onSubmit={() => { }}
                                                            onBlur={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>



                                            <div id="songMetadataEditor" style={{ padding: "5px 5px" }}>

                                                <SongMetadataEditor
                                                    key={getCurrentSongId}
                                                    onSave={handleSave}
                                                    onAddTag={handleAddTag}
                                                    onDeleteTag={handleDeleteTag}
                                                />

                                                <span id="editedSong" style={{ display: "none" }}></span>

                                                <br />
                                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                                    <button id="fixButton" className='button2' style={{ padding: "5px 5px", marginBottom: "40px", marginTop: "20 px", fontSize: "40px" }} onClick={() => window.fixSong()}>
                                                        Apply the fixes
                                                    </button>

                                                    <a style={{ fontSize: "10px", color: "white" }} id="downloadFixData" download="fixTickTrack.json" type="text/json">Download JSON data</a>
                                                    <br />
                                                </div>

                                            </div>
                                        </tr>
                                    </table>
                                </tr>
                            </div>
                            <div id="filterTable" style={{
                                display: "flex", flexDirection: "column", backgroundColor: "white", width: "800px", alignItems: "center",
                                margin: "0px 0px", padding: "0px 0px", borderRadiusLeft: "10px", borderRadiusRight: "10px"
                            }}>
                                <tr>
                                    <table>
                                        <tr style={{ padding: "5px 5px", fontSize: "35px" }}>
                                            <td>
                                                <span style={{ padding: "5px 5px", }}>Genre</span>
                                            </td>
                                            <td style={{ paddingLeft: "10px" }}>
                                                <span style={{}}>
                                                    Years
                                                </span>
                                            </td>
                                            <td style={{ paddingLeft: "10px" }}>
                                                <span style={{}}>Sort by</span>
                                            </td>
                                            <td style={{ paddingLeft: "10px" }}>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <select
                                                    style={{
                                                        padding: "5px 5px",
                                                        fontSize: "35px",
                                                        borderRadius: "5px",
                                                        //height: "12%",
                                                    }}
                                                    name="genreOptions"
                                                    id="genreOptions"
                                                    size="2"
                                                    onBlur={() => window.updateFilter()}
                                                    onSubmit={() => {
                                                        window.updateFilter();
                                                        //document.activeElement.blur();
                                                    }
                                                    }
                                                    onChange={() => window.updateFilter()}

                                                    multiple
                                                ></select>
                                            </td>
                                            <td style={{ paddingLeft: "10px" }}>
                                                <input
                                                    style={{ fontSize: "35px", width: "3.2em", height: "50px", borderRadius: "5px" }}
                                                    type="text"
                                                    id="minYear"
                                                    defaultValue=""
                                                    onSubmit={() => {
                                                        window.updateFilter();
                                                        document.activeElement.blur();
                                                    }
                                                    }
                                                    onBlur={() => window.updateFilter()}
                                                />
                                                <span style={{ fontSize: "35px" }}> - </span>
                                                <input
                                                    style={{ fontSize: "35px", width: "3.2em", height: "50px", borderRadius: "5px" }}
                                                    type="text"
                                                    id="maxYear"
                                                    defaultValue=""
                                                    onSubmit={() => {
                                                        window.updateFilter();
                                                        document.activeElement.blur();
                                                    }
                                                    }
                                                    onBlur={() => window.updateFilter()}
                                                />
                                            </td>
                                            <td style={{ paddingLeft: "10px" }}>
                                                <select
                                                    style={{ padding: "5px 5px", fontSize: "35px", borderRadius: "5px", height: "50px" }}
                                                    name="sortOptions"
                                                    id="sortOptions"
                                                    onChange={() => window.updateSort()}
                                                >
                                                    <option value="d">Date</option>
                                                    <option value="z">Views</option>
                                                    <option value="r">Views+</option>
                                                </select>
                                                <span style={{ padding: "5px 5px", fontSize: "35px", height: "45px" }}>
                                                    <button id="sortButton" className='button2' style={{ padding: "5px 5px", fontSize: "35px", fontWeight: "bold", width: "50px", backgroundColor: "darkblue", color: "white" }} onClick={() => window.changeSortDirection()}>
                                                        &#8595;
                                                    </button>
                                                </span>
                                            </td>
                                        </tr>
                                    </table>
                                </tr>
                                <tr>

                                    <td style={{ paddingLeft: "10px", paddingBottom: "0px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <div style={{ padding: "5px 5px", fontSize: "40px" }}>
                                            <button
                                                id="advancedOption"
                                                //className="button2"
                                                style={{
                                                    //padding: "5px 5px",
                                                    fontSize: "40px",
                                                    borderWidth: "0px",
                                                    backgroundColor: "white",
                                                    color: "darkblue",
                                                }}
                                                onClick={() => window.toggleAdvanced()}
                                            >
                                                <i class="fa-solid fa-angles-down"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>

                                {/*
                                <div class="form-card" style={{ display: "flex", flexDirection: "row", alignItems: "center", margin: 0, padding: 0, width: "100%" }}>
                                    
                                    <div class="form-group">
                                        <label for="genre1">Genre(s)</label>
                                        <select
                                            style={{
                                                padding: "5px 5px",
                                                fontSize: "35px",
                                                //height: "50px",
                                                width: "250px"
                                                //width: "600px",
                                                //height: "12%",
                                            }}
                                            name="genreOptions"
                                            id="genreOptions"
                                            size="3"
                                            multiple
                                        ></select>
                                    </div>
                                    <div class="form-group" style={{ display: "flex", justifyContent: "flex-start", flexDirection:"column", paddingLeft: "10px"}}>
                                        <label for="years">Year(s)</label>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
                                            <input
                                                style={{ fontSize: "30px", width: "90px", height: "50px", paddingLeft:3, paddingRight:3 }}
                                                type="text"
                                                id="minYear"
                                                placeholder='From:'
                                                defaultValue=""
                                            />
                                            <span style={{ fontSize: "40px" }}>{" "}-{" "}</span>
                                            <input
                                                style={{ fontSize: "30px", width: "90px", height: "50px", paddingLeft:3, paddingRight:3  }}
                                                type="text"
                                                id="maxYear"
                                                placeholder='To:'
                                                defaultValue=""
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group" style={{ display: "flex", justifyContent: "flex-start", flexDirection:"column", paddingLeft: "10px" }}>
                                        <label for="sort">Sort By</label>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
                                            <select
                                                style={{ padding: "5px 5px", fontSize: "35px", height: "50px", width: "160px" }}
                                                name="sortOptions"
                                                id="sortOptions"
                                                size="3"
                                            onChange={() => window.updateSort()}
                                            ><option value="d">Date</option>
                                                <option value="z">Views</option>
                                                <option value="r">Views+</option>
                                                
                                                <option value="c">Genius Contributors</option>
                                                <option value="w">Genius Page Views</option>
                                                
                                            </select>

                                            <span style={{ padding: "5px 5px", fontSize: "35px" }}>
                                                    <button id="sortButton" className='button2' style={{ padding: "5px 5px", fontSize: "35px", fontWeight:"bold", width:"50px", backgroundColor:"darkblue", color: "white" }} onClick={() => window.changeSortDirection()}>
                                                    &#8595;
                                                    </button>
                                                </span>
                                            
                                        </div>
                                    </div>
                                    <div class="form-group" style={{ display: "flex", justifyContent: "flex-start", flexDirection:"column", paddingLeft: "10px" }}>
                                        <label for="advanced">_</label>
                                        <div style={{ padding: "5px 5px", fontSize: "40px" }}>
                                                    <button
                                                        id="advancedOption"
                                                        //className="button2"
                                                        style={{
                                                            padding: "5px 5px",
                                                            fontSize: "40px",
                                                            borderWidth: "0px",
                                                            backgroundColor: "white",
                                                            color: "darkblue",
                                                        }}
                                                        onClick={() => window.toggleAdvanced()}
                                                    >
                                                        <i class="fa-solid fa-angles-down"></i>
                                                    </button>
                                                </div>
                                                </div>
                                </div>
                                */}

                                <div id="advancedFilters" style={{ display: "none", marginTop: 5, marginLeft: 0, paddingLeft: 0, width: "700px", alignItems: "center", justifyContent: "center" }}>
                                    <div class="form-card" style={{ width: "620px" }}>
                                        <div class="form-group" style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", }}>
                                            <label for="pack1">Pack</label>
                                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", }}>
                                                <select value={currentPack}
                                                    style={{ padding: "5px 5px", fontSize: "35px", width: "100%" }}
                                                    name="packOptions"
                                                    id="packOptions"
                                                    onChange={(evt) => {
                                                        setCurrentPack(evt.target.value);
                                                        handlePackChange(evt.target.value, true);
                                                        //window.updateFilter();
                                                    }
                                                    }
                                                ><option value="mostpop">Default | Most Popular (20K+ songs)</option>
                                                    <option value="sample1">Sample | Balanced (95K+ songs) </option>
                                                    <option value="rapfr">All French Rap (70K+ songs)</option>
                                                    <option value="benin">Benin (400+ songs)</option>
                                                    <option value="tests">Tests</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="search">Search</label>
                                            <input
                                                style={{ fontSize: "35px", width: "93%" }}
                                                type="text"
                                                id="search"
                                                placeholder='Search for songs, artists or videos'
                                                defaultValue=""
                                            />
                                        </div>
                                        <div class="form-group">
                                            <label for="style">Musical Style
                                                <button
                                                    id="toggleStyleSearchButton"
                                                    //className="button2"
                                                    style={{
                                                        padding: "5px 5px",
                                                        fontSize: "35px",
                                                        borderWidth: "0px",
                                                        backgroundColor: "white",
                                                        color: "darkblue",
                                                    }}
                                                    onClick={() => window.toggleStyleSearch()}
                                                >
                                                    <i class="fa-solid fa-angles-down"></i>
                                                </button>
                                            </label>
                                            <input
                                                style={{ fontSize: "35px", display: "none", width: "93%" }}
                                                type="text"
                                                id="styleSearch"
                                                defaultValue=""
                                                placeholder='Search for a style'
                                                onChange={() => window.buildStyleOptions()}
                                            />
                                            <div>
                                                <select
                                                    style={{

                                                        fontSize: "35px",
                                                        display: "none",
                                                        width: "100%",
                                                        //height: "12%",
                                                    }}
                                                    name="styleOptions"
                                                    id="styleOptions"
                                                    size="4"
                                                    multiple
                                                ></select>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="stats">Filter by popularity
                                                <button
                                                    id="toggleStatsSearchButton"
                                                    //className="button2"
                                                    style={{
                                                        //paddingTop: "40px",
                                                        //padding: "5px 5px",
                                                        fontSize: "40px",
                                                        borderWidth: "0px",
                                                        backgroundColor: "white",
                                                        color: "darkblue",
                                                    }}
                                                    onClick={() => window.toggleStatsSearch()}
                                                >
                                                    <i class="fa-solid fa-angles-down"></i>
                                                </button>
                                            </label>
                                            <div style={{ padding: "5px 5px", fontSize: "40px" }}>

                                                <select
                                                    style={{ display: "none", padding: "5px 5px", fontSize: "35px", borderWidth: "0px", width: "100%" }}
                                                    name="statsMetric"
                                                    id="statsMetric"
                                                //onChange={() => {
                                                //    window.switchStatsMetric()
                                                //}}
                                                >
                                                    <option value="z">Views</option>
                                                    <option value="r">Views+</option>

                                                    <option value="c">G Contributors</option>
                                                    <option value="w">G Views</option>
                                                </select>
                                            </div>
                                            <div id="statsValues" style={{ display: "none", flexDirection: "row", fontSize: "40px", justifyContent: "flex-start", alignItems: "center" }}>
                                                <input
                                                    style={{ fontSize: "35px", width: "39%", marginRight: 5 }}
                                                    type="text"
                                                    id="minViews"
                                                    defaultValue=""
                                                    placeholder='From: '
                                                //onChange={() => window.updateFilter()}
                                                />{" "}
                                                -{" "}
                                                <input
                                                    style={{ fontSize: "35px", width: "39%", marginLeft: 5 }}
                                                    type="text"
                                                    id="maxViews"
                                                    placeholder='To: '
                                                    defaultValue=""
                                                //onChange={() => window.updateFilter()}
                                                />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="location">Location(s)
                                                <button
                                                    id="toggleLocationSearchButton"
                                                    //className="button2"
                                                    style={{
                                                        padding: "5px 5px",
                                                        fontSize: "35px",
                                                        borderWidth: "0px",
                                                        backgroundColor: "white",
                                                        color: "darkblue",
                                                    }}
                                                    onClick={() => window.toggleLocationSearch()}
                                                >
                                                    <i class="fa-solid fa-angles-down"></i>
                                                </button>
                                            </label>
                                            <div id="locationFetcher" style={{ padding: "0px 0px", fontSize: "0.8em", borderWidth: 0, display: "none", flexDirection: "row" }}                                    >
                                                <LocationFetcher onLocationObtained={handleLocationObtained} />
                                            </div>
                                            <input
                                                style={{ fontSize: "35px", display: "none", width: "93%" }}
                                                type="text"
                                                id="locationSearch"
                                                placeholder='Search for a location'
                                                defaultValue=""
                                                onChange={() => window.buildLocationOptions()}
                                            />
                                            <div style={{ padding: "5px 5px", fontSize: "1.1em", borderWidth: 0, flexDirection: "column" }}  >
                                                {/*<label for="notnearyou"> Locations </label>*/}
                                                <select
                                                    style={{
                                                        padding: "5px 5px",
                                                        fontSize: "35px",
                                                        width: "100%",
                                                        display: "none",
                                                        //height: "12%",
                                                    }}
                                                    name="locationOptions"
                                                    id="locationOptions"
                                                    size="5"
                                                    multiple
                                                ></select>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="tags">Other Tags
                                                <button
                                                    id="toggleTagSearchButton"
                                                    //className="button2"
                                                    style={{
                                                        padding: "5px 5px",
                                                        fontSize: "35px",
                                                        borderWidth: "0px",
                                                        backgroundColor: "white",
                                                        color: "darkblue",
                                                    }}
                                                    onClick={() => window.toggleTagSearch()}
                                                >
                                                    <i class="fa-solid fa-angles-down"></i>
                                                </button>
                                            </label>
                                            <input
                                                style={{ fontSize: "35px", display: "none", width: "93%" }}
                                                type="text"
                                                id="tagSearch"
                                                defaultValue=""
                                                placeholder='Search for a tag'
                                                onChange={() => window.buildTagOptions()}
                                            />

                                            <div>
                                                <select
                                                    style={{
                                                        padding: "5px 5px",
                                                        fontSize: "35px",
                                                        width: "100%",
                                                        display: "none",
                                                        //height: "12%",
                                                    }}
                                                    name="tagOptions"
                                                    id="tagOptions"
                                                    size="5"
                                                    multiple
                                                ></select>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="map">Map Options</label>
                                            <select
                                                style={{ padding: "5px 5px", fontSize: "40px", width: "600px" }}
                                                name="mapPosition"
                                                id="mapPosition"
                                            >
                                                <option value="2">Below the video</option>
                                                <option value="1">Beside the video</option>
                                                <option value="0">No Map</option>
                                            </select>
                                            <span style={{ fontSize: "30px" }} >(Select "No Map" for older devices)</span>
                                        </div>
                                        {/*
                                        <button class="btn" onClick={
                                            () => submitPlayList1()
                                        } >
                                            PLAY
                                        </button>
*/}

                                        <td style={{ textAlign: "center" }}>
                                            <div style={{ display: "flex", flexDirection: "row", padding: 20, justifyContent: "center" }}>
                                                <button
                                                    class="btn"
                                                    id="resetFilters"
                                                    //className="button2"

                                                    style={{
                                                        padding: "5px 5px",
                                                        margin: "15px 15px",
                                                        fontSize: "40px",
                                                        //backgroundColor: "lightred",
                                                        color: "#fff",
                                                    }}

                                                    onClick={() => window.resetFilter()}
                                                >
                                                    RESET ALL
                                                </button>

                                                <button
                                                    id="filters"
                                                    class="btn"
                                                    //className="button2"

                                                    style={{
                                                        padding: "5px 5px",
                                                        margin: "15px 15px",
                                                        fontSize: "40px",
                                                        //backgroundColor: "darkblue",
                                                        color: "#fff",
                                                    }}

                                                    onClick={() => window.updateFilter()}
                                                >
                                                    APPLY FILTERS
                                                </button>
                                            </div>
                                        </td>
                                        {/*
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td style={{ paddingLeft: "0px" }}>
                                                    <br></br>
                                                    <div style={{ padding: "5px 5px", fontSize: "40px", borderWidth: 5, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}>

                                                        Map
                                                    </div>
                                                </td>
                                                <td style={{ paddingLeft: "0px" }}>
                                                    <span style={{ display: "none", padding: "5px 5px", fontSize: "40px" }}>
                                                        Information input
                                                    </span>
                                                </td>

                                            </tr>
                                            <tr>
                                                <td style={{ paddingLeft: "10px" }}>
                                                    <span style={{ display: "flex", fontSize: "40px" }}>

                                                        <select
                                                            style={{ padding: "5px 5px", fontSize: "40px" }}
                                                            name="mapPosition"
                                                            id="mapPosition"
                                                            onChange={() => {
                                                                window.updateMapPosition()
                                                            }}
                                                        >
                                                            <option value="2">Below the video</option>
                                                            <option value="1">Beside the video</option>
                                                            <option value="0">No Map</option>
                                                        </select>

                                                    </span>
                                                </td>
                                            </tr>

                                            
                                            <tr>
                                                <td>
                                                    <br></br>
                                                    <div style={{ padding: "5px 5px", fontSize: "40px", borderWidth: 5, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}>
                                                        Search
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "5px 5px", fontSize: "40px" }}>
                                                    <input
                                                        style={{ fontSize: "40px", width: "780px" }}
                                                        type="text"
                                                        id="search"
                                                        placeholder='Search for a song, an artist or a video'
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <td style={{ paddingLeft: "0px" }}>
                                                        <br></br>
                                                        <div style={{ display: "flex", padding: "5px 5px", fontSize: "40px", borderWidth: 5, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}>

                                                            <select
                                                                style={{ padding: "5px 5px", fontSize: "40px", borderWidth: "0px" }}
                                                                name="statsMetric"
                                                                id="statsMetric"
                                                            //onChange={() => {
                                                            //    window.switchStatsMetric()
                                                            //}}
                                                            >
                                                                <option value="z">Views</option>
                                                                <option value="r">Views+</option>
                                                                <option value="c">Genius Contributors</option>
                                                                <option value="w">Genius Views</option>
                                                            </select>

                                                        </div>
                                                    </td>
                                                </td>
                                            </tr>
                                            <tr>

                                                <td style={{ padding: "5px 5px", fontSize: "40px" }}>
                                                    <input
                                                        style={{ fontSize: "40px", width: "375px" }}
                                                        type="text"
                                                        id="minViews"
                                                        defaultValue=""
                                                        placeholder='From: '
                                                    //onChange={() => window.updateFilter()}
                                                    />{" "}
                                                    -{" "}
                                                    <input
                                                        style={{ fontSize: "40px", width: "375px" }}
                                                        type="text"
                                                        id="maxViews"
                                                        placeholder='To: '
                                                        defaultValue=""
                                                    //onChange={() => window.updateFilter()}
                                                    />

                                                    <div style={{ padding: "5px 5px", fontSize: "25px", display: "none" }}>
                                                        Reach
                                                        <input
                                                            style={{ fontSize: "25px", width: "5.7em" }}
                                                            type="text"
                                                            id="minReach"
                                                            defaultValue=""
                                                        //onChange={() => window.updateFilter()}
                                                        />{" "}
                                                        -{" "}
                                                        <input
                                                            style={{ fontSize: "25px", width: "5.7em" }}
                                                            type="text"
                                                            id="maxReach"
                                                            defaultValue=""
                                                        //onChange={() => window.updateFilter()}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <br></br>
                                                    <br></br>
                                                    <div style={{ padding: "5px 5px", fontSize: "40px", borderWidth: 5, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}
                                                        onClick={() => window.toggleLocationSearch()}>

                                                        Location
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input
                                                        style={{ display: "none", padding: "5px 5px", fontSize: "40px", width: "780px" }}
                                                        type="text"
                                                        id="locationSearch"
                                                        placeholder='Search for a location'
                                                        defaultValue=""
                                                        onChange={() => window.buildLocationOptions()}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div>
                                                        <select
                                                            style={{
                                                                padding: "5px 5px",
                                                                fontSize: "40px",
                                                                //height: "12%",
                                                                display: "none",
                                                                width: "800px",
                                                            }}
                                                            name="locationOptions"
                                                            id="locationOptions"
                                                            size="4"
                                                            multiple
                                                        ></select>
                                                    </div>
                                                </td>

                                            </tr>
                                            <tr style={{ padding: "25px 25px", }}>

                                            </tr>

                                            <tr style={{ margin: "15px 15px" }}>
                                                <td>
                                                    <br></br>
                                                    <br></br>
                                                    <div style={{ padding: "5px 5px", fontSize: "40px", borderWidth: 5, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}

                                                        onClick={() => window.toggleStyleSearch()}>
                                                        Musical Style
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input
                                                        style={{ padding: "5px 5px", fontSize: "40px", width: "750px", display: "none" }}
                                                        type="text"
                                                        id="styleSearch"
                                                        defaultValue=""
                                                        placeholder='Search for a style'
                                                        onChange={() => window.buildStyleOptions()}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>

                                                <td >
                                                    <div>
                                                        <select
                                                            style={{
                                                                padding: "5px 5px",
                                                                fontSize: "40px",
                                                                display: "none",
                                                                width: "800px",
                                                                //height: "12%",
                                                            }}
                                                            name="styleOptions"
                                                            id="styleOptions"
                                                            size="4"
                                                            multiple
                                                        ></select>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <br></br>
                                                    <br></br>
                                                    <div style={{ padding: "5px 5px", fontSize: "40px", borderWidth: 5, borderRadius: 5, borderStyle: "solid", borderColor: "darkblue" }}
                                                        onClick={() => window.toggleTagSearch()}

                                                    >

                                                        Other tags
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <input
                                                        style={{ display: "none", padding: "5px 5px", fontSize: "40px", width: "780px" }}
                                                        type="text"
                                                        id="tagSearch"
                                                        defaultValue=""
                                                        placeholder='Search for a tag'
                                                        onChange={() => window.buildTagOptions()}
                                                    />
                                                </td>
                                            </tr>

                                            <tr>
                                                <td >
                                                    <div>
                                                        <select
                                                            style={{
                                                                padding: "5px 5px",
                                                                fontSize: "40px",
                                                                width: "800px",
                                                                display: "none",
                                                                //height: "12%",
                                                            }}
                                                            name="tagOptions"
                                                            id="tagOptions"
                                                            size="5"
                                                            multiple
                                                        ></select>
                                                    </div>
                                                </td>


                                            </tr>

                                            
                                            <tr style={{}}>
                                                <td style={{ textAlign: "center" }}>
                                                    <div style={{ display: "flex", flexDirection: "row", padding: 20, justifyContent: "center" }}>
                                                        <button
                                                            id="resetFilters"
                                                            className="button2"
                                                            style={{
                                                                padding: "5px 5px",
                                                                margin: "15px 15px",
                                                                fontSize: "40px",
                                                                backgroundColor: "darkblue",
                                                                color: "#fff",
                                                            }}
                                                            onClick={() => window.resetFilter()}
                                                        >
                                                            RESET ALL
                                                        </button>

                                                        <button
                                                            id="filters"
                                                            className="button2"
                                                            style={{
                                                                padding: "5px 5px",
                                                                margin: "15px 15px",
                                                                fontSize: "40px",
                                                                backgroundColor: "darkblue",
                                                                color: "#fff",
                                                            }}
                                                            onClick={() => window.updateFilter()}
                                                        >
                                                            APPLY FILTERS
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table >

                                    */}
                                    </div>

                                </div>


                            </div>
                            <div id="statsTable" style={{ display: "none", backgroundColor: "white", width: "800px" }}>
                                <tr>
                                    <table>
                                        <tr style={{ padding: "5px 5px", fontSize: "30px" }}>

                                            Stats about songs watched per genre, country, and year
                                            <div id="basicStats"
                                                style={{ textAlign: "left", padding: "20px 20px", fontSize: "30px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                            </div>
                                        </tr>
                                    </table>
                                </tr>
                            </div>
                            <div id="libraryTable" style={{ display: "none", backgroundColor: "white", width: "800px" }}>
                                <tr>
                                    <table>
                                        <tr style={{ padding: "5px 5px", fontSize: "35px", paddingTop: "50px", gap: "10px" }}>
                                            <div style={{ display: "flex", flex: 1, padding: "5px 5px", flexDirection: "row", alignItems: "flex-center", justifyContent: "center" }}>
                                                <select id="libraryOperation" style={{ margin: "5px 5px", fontSize: "35px", paddingRight: "10px" }}
                                                    onChange={() => window.updateLibrarySelection()}
                                                >
                                                    <option value="0"> --- </option>
                                                    <option value="1"> Only </option>
                                                    <option value="2"> Include </option>
                                                    <option value="3"> Exclude </option>
                                                </select>
                                                songs rated
                                                <select
                                                    style={{ margin: "5px 5px", fontSize: "35px", paddingLeft: "10px" }}
                                                    name="ratingComparison"
                                                    id="ratingComparison"
                                                    onChange={() => window.updateLibrarySelection()}
                                                >
                                                    <option value="0"> any </option>
                                                    <option value="<"> less than </option>
                                                    <option value="<="> at least </option>
                                                    <option value="="> exactly </option>
                                                    <option value=">="> at most </option>
                                                    <option value=">"> more than </option>
                                                </select>
                                                <select
                                                    style={{ margin: "5px 5px", fontSize: "35px" }}
                                                    name="ratingThreshold"
                                                    id="ratingThreshold"
                                                    onChange={() => window.updateLibrarySelection()}
                                                >
                                                    <option value="0"> ☆☆☆☆☆ </option>
                                                    <option value="1"> ★☆☆☆☆ </option>
                                                    <option value="2"> ★★☆☆☆ </option>
                                                    <option value="3"> ★★★☆☆ </option>
                                                    <option value="4"> ★★★★☆ </option>
                                                    <option value="5"> ★★★★★ </option>
                                                </select>
                                            </div>


                                        </tr>
                                        <tr>

                                            <div style={{
                                                padding: "5px 5px", flex: 1, fontSize: "35px",
                                                display: "flex",
                                                flexDirection: "row", alignItems: "flex-center", justifyContent: "center"
                                            }}>
                                                <button id="validateLibrary" style={{
                                                    margin: "5px 5px", fontSize: "35px",
                                                    color: "#fff", backgroundColor: "darkblue", padding: "5px 5px", borderRadius: "5px"
                                                }}
                                                    onClick={() => window.processLibrary()}
                                                >
                                                    Apply
                                                </button>
                                            </div>
                                        </tr>
                                    </table>
                                </tr>
                            </div>


                        </tbody>
                    </table>


                    <div
                        id="mapContainer"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            borderRadius: "5px",
                            //alignItems: "center",
                        }}
                    >
                        <div
                            style={{
                                paddingLeft: "0px",
                                border: "none",
                                height: "620px",
                                width: "800px",
                                borderRadius: "10px",
                                //backgroundColor: "lightgrey",
                            }}
                            id="map"
                        >
                        </div>

                        <div
                            id="year-slider"
                            style={{
                                display: "none",
                                flexDirection: "row",
                                color: "darkblue",
                                justifyContent: "center",
                                paddingLeft: "20px",
                                border: "none",
                                width: "750px",
                                margin: "10px 0",
                            }}
                        >

                        </div>

                    </div>


                </div>



                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div style={{ visibility: "hidden" }}>
                                    <textarea id="videoInfo" name="videoInfo" rows="1" cols="1">
                                        ...
                                    </textarea>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table style={{ backgroundColor: "white", width: "800px" }}>
                    <tbody>

                        {/* Video box image and text */}
                        <tr style={{ paddingLeft: "0px", border: "none", width: "800px" }}>
                            <div style={{ alignContent: "flex-start", textAlign: "flex-start", display: "flex", flexDirection: "row" }}>
                                <div
                                    id="videoBoxImage"
                                    style={{
                                        //width: "30%",
                                        flex: 0.25,
                                        
                                        wordWrap: "break-word",
                                        fontSize: "25px",
                                    }}
                                >

                                </div>
                                <div
                                    id="videoBoxText"
                                    style={{
                                        //width: "70%",
                                        flex: 0.75,
                                        fontFamily: "Arial, sans-serif",
                                        wordWrap: "break-word",
                                        fontSize: "20px",
                                    }}
                                >

                                </div>
                            </div>
                        </tr>
                        <tr style={{ paddingLeft: "0px", border: "none", width: "700px", display: "flex", flexDirection: "column", alignContent: "center", justifyContent: "center" }}>    
                            
                            <div
                                    id="artistsBox"
                                    //style={{
                                        //width: "70%",
                                    //    flex: 1,
                                    //    wordWrap: "break-word",
                                    //    fontSize: "20px",
                                    //}}
                                >
                            </div>
                        </tr>

                        <tr style={{ textAlign: "center" }}>
                            <td >
                                <button
                                    id="GIFs"
                                    className="button2"
                                    style={{
                                        padding: "5px 5px",
                                        margin: "0px 10px",
                                        fontSize: "25px",
                                        backgroundColor: "darkblue",
                                        color: "#fff",
                                    }}
                                    onClick={() => window.toggleGIFs()}
                                >
                                    GIFs
                                </button>
                            </td>
                        </tr>

                    </tbody>
                </table>

                <div style={{ paddingLeft: "0px" }}>
                    <iframe
                        style={{
                            paddingLeft: "0px",
                            border: "none",
                            height: "800px",
                            width: "800px",
                            display: "none",
                        }}
                        allowFullScreen
                        id="iframe"
                        src="https://www.bing.com/images/search?q=music&form=HDRSC2&first=1&scenario=ImageBasicHover"
                        name="iframe"
                        title="Image Search"
                    ></iframe>
                </div>
            </div >
        </div>
    );
};

export default MyPage;
